import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { BussinessAppUserInjection } from "features/businessAppUserManagement/di/BussinessAppUserInjection";
import { injectable } from "tsyringe";
import { paramsChecking } from "utils/helpersInTs/helpersInTs";
import { BussinessAppUserRequestEntity } from "../entities/BussinessAppUserRequestEntity";
import { BussinessAppUserResponseEntity } from "../entities/BussinessAppUserResponseEntity";
import { IBussinessAppUserRepository } from "../repositories/IBussinessAppUserRepository";

@injectable()
export class BussinessAppUserUseCase {
  private bussinessAppUserRepo: IBussinessAppUserRepository;

  constructor() {
    this.bussinessAppUserRepo = BussinessAppUserInjection.getRepo();
  }

  private checkParams(
    params: BussinessAppUserRequestEntity,
  ): BussinessAppUserRequestEntity {
    return {
      ...params,
      status: paramsChecking(params?.status, "select"),
      phone: paramsChecking(params?.phone, "input"),
      fullName: paramsChecking(params?.fullName, "input"),
      code: paramsChecking(params?.code, "input"),
    };
  }

  async getUsers(
    params: BussinessAppUserRequestEntity,
  ): Promise<ListBaseApiResponseModel<BussinessAppUserResponseEntity>> {
    const updatedParams = this.checkParams(params);
    return await this.bussinessAppUserRepo.getList(updatedParams);
  }

  async getBusinessAppUserDetail(
    params: BussinessAppUserRequestEntity,
  ): Promise<BaseApiResponseModel<BussinessAppUserResponseEntity>> {
    return await this.bussinessAppUserRepo.getDetail(params);
  }

  async resetOtpUser(
    phone: string,
  ): Promise<
    BaseApiResponseModel<{ phone?: string; deleteOtpCount?: number }>
  > {
    return await this.bussinessAppUserRepo.resetOtpUser(phone);
  }
}
